var exportFns = {};

var getColorMsg = require('./colormsg.js');

var msgTypes = require('./msgTypes')();

function logMsg(type) {
  return function (msg, original) {
    console.log(getColorMsg(type, msg, original));
  };
}

Object.keys(msgTypes).map(function (k) {
  return exportFns[k] = logMsg(k);
});
module.exports = exportFns;